module.exports = __webpack_public_path__ + "img/authed.2ac7b573.png";